// extracted by mini-css-extract-plugin
module.exports = {"tab":"SsItem_tab__1E5YO","active":"SsItem_active__2l3T-"};